import type { ProductSummaryMetadata } from 'components/common-form/sidePanel/docToolbar/summary/builder/model';
import type { EmailDescriptionApi } from 'epic/static-form/product-summary';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

type YesNo = 'Yes' | 'No';

function toYesNoOrUndefined(value: boolean | YesNo | undefined): YesNo | undefined {
  if (value === undefined) {
    return undefined;
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  return value;
}

export function getProductSummary(http: IHttpClient): EmailDescriptionApi {
  return {
    getProductSummary(summaryPostData) {
      return http
        .postJSON<ProductSummaryMetadata>({
          url: `api/v2/static-form/product-summary-metadata`,
          body: {
            ...summaryPostData,
            // TODO: remove the 2 lines below when the IsMagnet and IsMagnetMin fields are converted to a YES/NO field in the static screen
            IsMagnet: toYesNoOrUndefined(summaryPostData.IsMagnet),
            IsMagnetMin: toYesNoOrUndefined(summaryPostData.IsMagnetMin),
          },
        })
        .pipe(
          map(reponse => {
            return reponse.payload;
          }),
        );
    },
  };
}
